import { DataTable } from "../../../components";
import DateColumn from "./DateColumn";
import ExpandedRow from "./expandedRow";
import statusCodes from "../../../utils/constants/status.codes";
import { MdCheckCircle } from "react-icons/md";

function InboxTable({
  data,
  sortColumn,
  sortType,
  onSortColumn,
  loading,
  activeFilters,
  onFilterClick,
  // Pagination props
  currentPage,
  pageSize,
  totalItems,
  onPageChange,
  onPageSizeChange,
}) {
  const columns = [
    {
      key: "emailSubject",
      dataKey: "emailSubject",
      title: "Centre Name",
      width: 150,
      flexGrow: 2,
      sortable: true,
      filterable: true,
    },
    {
      key: "dateProcessed",
      dataKey: "dateProcessed",
      title: "Date Processed",
      width: 130,
      sortable: true,
      filterable: false,
      fixed: true,
      type: "date",
      render: (rowData) => <DateColumn dataKey="dateProcessed" rowData={rowData} />,
    },
    {
      key: "statusCode",
      dataKey: "statusCode",
      title: "Status",
      width: 120,
      sortable: true,
      flexGrow: 1,
      filterable: true,
      render: (rowData) => statusCodes[rowData.statusCode] || rowData.statusCode,
    },
     {
      key: "grandTotal",
      dataKey: "grandTotal",
      title: "Grand Total",
      width: 120,
      sortable: true,
      filterable: false,
      render: (rowData) => rowData.grandTotal ? `$${rowData.grandTotal?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : "-",
    },
    {
      key: "exported",
      dataKey: "exported",
      title: "Exported",
      width: 140,
      sortable: true,
      filterable: true,
      render: (rowData) => (rowData.exported ? <MdCheckCircle className="success-icon" /> : ""),
    },
    {
      key: "processAttempts",
      dataKey: "processAttempts",
      title: "Attempts",
      width: 100,
      sortable: true,
      filterable: false,
      resizable: true,
    },
  ];
  return (
    <DataTable
      data={data}
      columns={columns}
      sortColumn={sortColumn}
      sortType={sortType}
      onSortColumn={onSortColumn}
      loading={loading}
      activeFilters={activeFilters}
      onFilterClick={onFilterClick}
      expandable={true}
      renderRowExpanded={ExpandedRow}
      rowExpandedHeight={600}
      showRowCount={true}
      currentPage={currentPage}
      pageSize={pageSize}
      totalItems={totalItems}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
    />
  );
}

export default InboxTable;
